import { Book } from 'ui/icons/other/Book';
import { AngularLink, StyledRouterLink } from './Link.styled';

// type Props = {
//   /** Text of link or additional content. */
//   children: React.ReactNode,
//   /** Disabled Link. */
//   disabled?: boolean,
//   /** Adds doc icon to front if link leads to documentation. */
//   docLink?: boolean,
//   /** Opens link in new window. */
//   openInNewContext?: boolean,
//   /** Stylize as table link. */
//   tableLink?: boolean,
//   /** Stylize as primary table link. */
//   tableLinkPrimary?: boolean,
//   /** Path of link. Renders a React Link. */
//   to?: string,
//   /** Text of the link. */
//   text?: string,
//   /** URL of the link. */
//   url?: string,
// };

/**
 * Links lead to a different page (url) when clicked on.
 */
const Link = ({
  children,
  disabled,
  docLink,
  openInNewContext,
  tableLink,
  tableLinkPrimary,
  text,
  to,
  url,
  ...otherProps
}) => {
  const contents = (
    <>
      {docLink && <Book height={16} />}
      {text}
      {children}
    </>
  );

  return to ? (
    <StyledRouterLink
      $tableLink={tableLink}
      $tableLinkPrimary={tableLinkPrimary}
      disabled={disabled}
      target={openInNewContext ? '_blank' : undefined}
      to={{ pathname: to }}
      {...otherProps}
    >
      {contents}
    </StyledRouterLink>
  ) : (
    <AngularLink
      $tableLinkPrimary={tableLinkPrimary}
      disabled={disabled}
      target={openInNewContext ? '_blank' : undefined}
      href={url}
      {...otherProps}
    >
      {contents}
    </AngularLink>
  );
};

export default Link;
